import { gql } from "@apollo/client";
export const GET_EMPLOYEE_TIMESHEET = gql`
  query ($model: GetEmployeeTimesheetRequestModelInput!) {
    GetEmployeeTimesheet(model: $model) {
      employeeTimesheet {
        totalDuration
        totalBillableDuration
        totalNonBillableDuration
        dateSummaries {
          date
          totalDurationByDate
          billableDurationByDate
          nonBillableDurationByDate
        }
        taskSummaries {
          projectGuid
          projectTitle
          taskGuid
          taskName
          totalTaskDuration
          totalBillableDuration
          totalNonBillableDuration
          dateDetails {
            date
            billableDuration
            nonBillableDuration
            totalDuration
          }
        }
      }
      errorCode
      errorMessage
      errorVariables
    }
  }
`;



export const GET_TIME_BY_EMPLOYEE = gql`
  query ($model: GetTimeByEmployeeRequestModelInput!) {
    GetTimeByEmployee(model: $model) {
      timeByEmployee {
        employees {
          id
          name
          nonBillableHours
              billableHours  
          totalOfHours
          projects {
            id
            name
            totalOfHours
            percentageOfTotal
            nonBillableHours
              billableHours  
            tasks {
              id
              name
              billable
              nonBillableHours
              billableHours  
              totalOfHours
            }
          }
        }
      }
      errorCode
      errorMessage
      errorVariables
    }
  }
`;

export const GET_TIME_BY_PROJECT = gql`
  query ($model: GetTimeByEmployeeRequestModelInput!) {
    GetTimeByProject(model: $model) {
      timeByProject {
        totalProjectsTime 
        projects {
          id
          name
          totalOfHours
          nonBillableHours
              billableHours  
          employees {
            id
            name
            totalOfHours
            nonBillableHours
              billableHours  
            percentageOfTotal
            tasks {
              id
              name
               
            nonBillableHours
              billableHours  
              billable
              totalOfHours
            }
          }
        }
      }
      errorCode
      errorMessage
      errorVariables
    }
  }
`;

export const GET_ATTENDANCE_BY_EMPLOYEE = gql`
query ($model: EmployeeAttendanceByDateRequestInput!) {
  GetAttendanceByEmployee(model: $model) {
    attendanceByEmployee {
      employeeGuid
      employeeName
      totalTime
      totalWorkHours
      attendanceGroups {
        date
        workshiftStartHour
        workshiftEndHour
        clockInTime
        clockOutTime
        totalTime
        isLate
        leftEarly
        automaticallyClockedOut
        dayLogs {
          dayLogGuid
          checkInTime
          checkOutTime
          workTimeHour
          workTimeMinute
          workType {
            mnemonic
            description
          }
          location {
            name
          }
          locationTo{
          name
          }
          toEntitlement {
            employeePTO {
              pto {
                ptoGuid
                description
              }
            }
          }
        }
      }
    }
    errorCode
    errorMessage
    errorVariables
  }
}
`;

export const GET_TIME_BY_EXTERNAL_REFERENCE = gql`
query($model: GetTimeByExternalReferenceRequestModelInput!) {
  GetTimeByExternalReferences(model: $model) {
      timeByExternalReference {
        projects {
          name
          totalOfHours
          tasks {
            name
            totalOfHours
            employees {
              name
              totalOfHours
            }
          }
        }
      }
    errorCode
    errorMessage
    errorVariables
  }
}
`;

export const EXPORT_TO_EXCEL= gql`
query($model:ProjectTimeEntriesForExcelFiltersRequestInput!){
  ProjectExportTimeEntries (model: $model) {
    projectTimeEntriesListForExcel {
      timeEntries{
        timeEntryGuid
        isEditable  
        taskTitle
        resourceName
        description
        date
        duration
        billable
         task {
          taskGuid
          title 
          ticket {
            project {
              projectGuid
              title
              projectPermissions {
                resourceGuid
                canManageTimeEntries
              }
            }
          }
          parentTaskGuid
        }
      }
      totalNumberOfRecords
    }
    errorCode
    errorMessage
    errorVariables
  }
}
`;